"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = uniqueID;

var _mathRandom = _interopRequireDefault(require("math-random"));

/* eslint no-magic-numbers: ["error", { "ignore": [2, 36] }] */
function uniqueID() {
  return (0, _mathRandom["default"])().toString(36).substring(2);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1bmlxdWVJRCIsInJhbmRvbSIsInRvU3RyaW5nIiwic3Vic3RyaW5nIl0sInNvdXJjZVJvb3QiOiJjb3JlOi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3V0aWxzL3VuaXF1ZUlELnRzIl0sInNvdXJjZXNDb250ZW50IjpbIi8qIGVzbGludCBuby1tYWdpYy1udW1iZXJzOiBbXCJlcnJvclwiLCB7IFwiaWdub3JlXCI6IFsyLCAzNl0gfV0gKi9cblxuaW1wb3J0IHJhbmRvbSBmcm9tICdtYXRoLXJhbmRvbSc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVuaXF1ZUlEKCk6IHN0cmluZyB7XG4gIHJldHVybiByYW5kb20oKS50b1N0cmluZygzNikuc3Vic3RyaW5nKDIpO1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFFQTs7QUFGQTtBQUllLFNBQVNBLFFBQVQsR0FBNEI7RUFDekMsT0FBTyxJQUFBQyxzQkFBQSxJQUFTQyxRQUFULENBQWtCLEVBQWxCLEVBQXNCQyxTQUF0QixDQUFnQyxDQUFoQyxDQUFQO0FBQ0QifQ==